import { render, staticRenderFns } from "./add-risk-score-summary.vue?vue&type=template&id=49a531bc&scoped=true&"
import script from "./add-risk-score-summary.vue?vue&type=script&lang=js&"
export * from "./add-risk-score-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a531bc",
  null
  
)

export default component.exports